export default "__VITE_ASSET__C$VAEETT__"